import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import Loader from './loader';

export const MaterialsLayout = ({ loading, setLoading, badges, label = 'MATERIALS' }) => {
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, [setLoading]);

  if (loading) {
    return <Loader showText={false} />;
  }

  return (
    <div className='run-workstation-materials'>
      <div className='run-workstation-materials__label'>{label}</div>
      <div className='run-workstation-materials__grid'>
        {badges.map((badge, index) => (
          <OverlayTrigger
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            placement='top'
            overlay={<Tooltip id={`tooltip-${index}`}>{badge.tooltip}</Tooltip>}
          >
            <div className={`run-workstation-materials__badge ${badge.className || ''}`}>
              {badge.icon && (
                <FontAwesomeIcon
                  icon={badge.icon}
                  className='run-workstation-materials__badge-icon'
                />
              )}
              <span>{badge.text}</span>
            </div>
          </OverlayTrigger>
        ))}
      </div>
    </div>
  );
};

MaterialsLayout.propTypes = {
  loading: PropTypes.bool.isRequired,
  setLoading: PropTypes.func.isRequired,
  label: PropTypes.string,
  badges: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.object,
      text: PropTypes.node.isRequired,
      tooltip: PropTypes.string.isRequired,
      className: PropTypes.string,
    })
  ).isRequired,
};
